export enum CemInterviewFeedback {
  EmployerHasNoFittingVacancy = 'no_fitting_vacancy',
  CandidateHasNoQualifications = 'no_qualifications',
  EmployerAlreadyKnowsCandidate = 'familiar_candidate',
  CandidateNotSuitable = 'negative_interview_result',
  CandidateNoShow = 'candidate_no_show',
  CandidateNeedsPlaceToLive = 'candidate_needs_place',
  CandidateFoundAnotherJob = 'found_another_job',
  CandidateFoundAnotherJobViaSite = 'found_another_job_via_site',
  CandidateStaysWithCurrentEmployer = 'happy_with_current_job',
  CandidateGhosted = 'candidate_ghosted',
  CandidateNotInterested = 'candidate_not_interested',
  TooFarFromCandidateLocation = 'too_far',
  CandidateNotInterestedInBenefitsOffered = 'not_interested_in_benefits',
  CandidateUnhealthy = 'candidate_ill',
  Others = 'others',
  SalaryDoesNotMatch = 'salary_no_match',
  InterviewFeedback = 'interview_feedback',
}
